export default theme => ({
    mainContentContainer: {
        display: 'flex',
        width: '100%',
        padding: theme.spacing.unit*2
    },
});